import './ResolutionError.scss'
import ErrorImage from '../../assets/images/ErrorImage.svg'

function ResolutionError() {
    return (
        <div className='resolution-error-container'>
            <img className='error-image' src={ErrorImage} />
            <div className="error-content">Your current screen size does not meet the minimum requirements to use this application.</div>
            <div className="error-message">Minimum Screen Width: 1024px</div>
        </div>

    )
}

export default ResolutionError